module.exports = __webpack_public_path__ + "static/img/measurement02.abba0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/measurements/measurement02.png
// module id = 15
// module chunks = 1